<template>
  <div>
    HTML
    <hr>
    <b-form-group :class="{'error-input' : $v.data_html.title.$error}">
      <label> HTML Title </label>
      <j-input
        v-model="$v.data_html.title.$model"
        :max-length="255"
        placeholder="HTML Title"/>
    </b-form-group>
    <quill-editor
      ref="myQuillEditor"
      v-model="data_html.html"
      :options="editorOption"
    />
    <b-row class="mt-4">
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeHtml">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveHtml">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import he from 'he';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_html: {
      title: {
        required,
      },
      html: {},
    },
  },
  data() {
    return {
      data_html: {
        title: '',
        html: '',
      },
      config: {
        attribution: false,
        events: {
          initialized() {
            // console.log('initialized');
          },
        },
      },
      editorOption: {

      },
    };
  },
  computed: {

    generateDataHtml() {
      const data = {
        value_id: '0',
        widget_master_id: this.dataMaster.id,
        info: JSON.stringify({
          name: this.data_html.title,
          html: this.encodeHtmlEntities(this.data_html.html),
        }),

        type: 3,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataHtmlUpdate() {
      const data = {
        widget_master_id: this.dataMaster.id,
        info: JSON.stringify({
          name: this.data_html.title,
          html: this.encodeHtmlEntities(this.data_html.html),
        }),

        type: 3,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_html.title = JSON.parse(this.dataEdit.info).name;
      this.data_html.html = he.decode(JSON.parse(this.dataEdit.info).html);
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),
    saveHtml() {
      this.$v.data_html.$touch();
      if (!this.$v.data_html.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataHtml;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataHtmlUpdate;
          this.updateWidget({ widgetId, dataParam });
        }

        this.closeHtml();
      }
    },

    closeHtml() {
      this.$emit('close-field');
      this.data_html.title = '';
      this.data_html.html = '';
      setTimeout(() => {
        this.$v.data_html.$reset();
      }, 1000);
    },

    encodeHtmlEntities(str) {
      return he.encode(str);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jHtmlSetup.vue